export class FileTypeHelper {
  private static readonly mimeTypeMappings: Record<string, string> = {
    // Image MIME Types
    'image/jpeg': 'image',
    'image/png': 'image',
    'image/bmp': 'image',
    'image/tiff': 'image',
    'image/gif': 'image',
    'image/svg+xml': 'image',
    'image/heic': 'image',
    'image/heif': 'image',
    'image/webp': 'image',
    'image/jp2': 'image',
    'image/x-icon': 'image',

    // PDF MIME Type
    'application/pdf': 'pdf',

    // Video MIME Types
    'video/mp4': 'video',
    'video/quicktime': 'video', // mov
    'video/mpeg': 'video',
    'video/x-msvideo': 'video', // avi
    'video/x-ms-wmv': 'video',  // wmv
    'video/x-flv': 'video',     // flv
    'video/webm': 'video',

    // Text MIME Types
    'text/plain': 'text',
    'application/rtf': 'text',

    // Office MIME Types (Microsoft Office)
    'application/msword': 'office',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'office',
    'application/vnd.ms-excel': 'office',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'office',
    'application/vnd.ms-powerpoint': 'office',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'office',

    // OpenOffice and LibreOffice MIME Types
    'application/vnd.oasis.opendocument.text': 'office',
    'application/vnd.oasis.opendocument.spreadsheet': 'office',
    'application/vnd.oasis.opendocument.presentation': 'office',
    'application/vnd.oasis.opendocument.graphics': 'office',
    'application/vnd.oasis.opendocument.chart': 'office',
    'application/vnd.oasis.opendocument.formula': 'office',

    // GPX files
    'application/gpx+xml': 'gpx'
  };

  public static getFileTypeFromMimeType(mimeType: string, fileName: string): string {
    // Check if the mimeType exists in the mappings dictionary
    if (FileTypeHelper.mimeTypeMappings[mimeType]) {
      return FileTypeHelper.mimeTypeMappings[mimeType];
    }

    // If no match is found, extract and return the file extension as default
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : 'unknown';
  }

  public static getImageMimeType(filename: string) : string {
    const extension = filename.split('.').pop()?.toLowerCase() || '';
    switch (extension) {
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'tif':
      case 'tiff':
        return 'image/tiff';
      case 'heic':
      case 'heif':
        return 'image/heic';
      case 'ico':
      case 'cur':
        return 'image/x-icon';
      case 'jp2':
      case 'j2k':
      case 'jpf':
      case 'jpx':
      case 'jpm':
        return 'image/jp2';
      case 'avif':
        return 'image/avif';
      case 'gpx':
        return 'application/gpx+xml';
      default:
        return `image/${extension || 'octet-stream'}`; // Fallback for unknown types
    }
  };
}
